import {useEffect, useRef} from "react";

const STICKY_CLASS = "is-stuck";

export const useTableHeaderSticky = () => {
    const elementBeforeStickyRef = useRef<HTMLDivElement>(null);
    const stickyElementRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!elementBeforeStickyRef.current) {
            return;
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.intersectionRatio === 0) {
                    stickyElementRef.current?.classList.add(STICKY_CLASS);
                } else if (entry.intersectionRatio === 1) {
                    stickyElementRef.current?.classList.remove(STICKY_CLASS);
                }
            },
            {threshold: [0, 1]}
        );

        observer.observe(elementBeforeStickyRef.current);

        return () => {
            observer.disconnect();
        };
    }, [elementBeforeStickyRef.current]);

    return {
        elementBeforeStickyRef,
        stickyElementRef
    };
};
import {useEffect, useRef} from "react";

const STICKY_CLASS = "is-stuck";

export const useTableHeaderSticky = () => {
    const elementBeforeStickyRef = useRef<HTMLDivElement>(null);
    const stickyElementRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!elementBeforeStickyRef.current) {
            return;
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.intersectionRatio === 0) {
                    stickyElementRef.current?.classList.add(STICKY_CLASS);
                } else if (entry.intersectionRatio === 1) {
                    stickyElementRef.current?.classList.remove(STICKY_CLASS);
                }
            },
            {threshold: [0, 1]}
        );

        observer.observe(elementBeforeStickyRef.current);

        return () => {
            observer.disconnect();
        };
    }, [elementBeforeStickyRef.current]);

    return {
        elementBeforeStickyRef,
        stickyElementRef
    };
};
